import { createTheme as createEcloTheme } from '@eclo/mode'
import { themeConfig } from './theme.config'

export const createTheme = () => {
	return createEcloTheme(themeConfig)
}
